<template>
  <div class="outer bg">
    <div class="inner behind">
      <img :src="require('@/assets/skatmasters/skat_assets_behind.png')" class="cards" alt="Shiny cards" />
    </div>
    <div class="shadow masters"></div>
    <div class="inner front">
      <img :src="require('@/assets/skatmasters/skat_logo.png')" class="logo" alt="Skat Masters logo" />
      <img :src="require('@/assets/skatmasters/trophy.png')" class="trophy" />
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style lang="less" scoped>
@import '~@npm/@gd/common-styles/lib/color-vars';
@import '../../styles/vars';
.bg {
  background: #247001 url('../../assets/skatmasters/skat_bg.jpg');
}

.logo {
  position: absolute;
  width: 16.8125em;
  height: 7.1875em;
  left: 0;
  margin-top: -0.25em;
  justify-self: center;
  top: 1.45em;
  @media screen and (max-width: @framemaxwidth) {
    left: 1.25em;
  }
}

.behind {
  overflow: hidden;
}

.cards {
  position: absolute;
  width: 34.8125em;
  height: 15em;
  bottom: 0;
  right: 0;
  @media screen and (max-width: 760px) {
    right: -10em;
  }
}

.shadow {
  background: linear-gradient(to bottom, rgba(237, 244, 179, 0.2) 0%, rgba(0, 0, 0, 0.1) 100%);
  position: relative;
  &:after {
    content: '';
    position: absolute;
    width: 100%;
    height: 2em;
    left: 0;
    bottom: 0;
    box-shadow: 0 -2em 0.5em -1.8em rgba(0, 0, 0, 0.35) inset;
  }
}

.trophy {
  position: absolute;
  width: 8.375em;
  height: 10.625em;
  right: 13em;
  bottom: -0.9em;
  @media screen and (max-width: 760px) {
    right: 3em;
  }
}
</style>
